import type { ShareLinkData, ShareLinkResponse } from '../types';

export const ShareIdApi = Symbol('ShareIdApi');

export interface ShareIdApi {
    getShareIdForGuest(inputData: ShareLinkData): Promise<ShareLinkResponse>
    getShareId(inputData: ShareLinkData): Promise<ShareLinkResponse>
}
